import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './state'
//import "./registerServiceWorker";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faEyeSlash, faTimes, faCheck, faExclamation, faMoon } from '@fortawesome/free-solid-svg-icons'
import { faMoon as farMoon } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faEye)
library.add(faEyeSlash)
library.add(faCheck)
library.add(faTimes)
library.add(faExclamation)
library.add(faMoon)
library.add(farMoon)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
